import { useState, useEffect } from 'react'
import i18n from '../../../i18n'
import { bruktbilfinansieringAPI } from '../../../services/api'
import type { BankMarketResponse } from '../../../types/bruktbilfinansiering'
import type { BruktbilfinansieringFilters } from './useBruktbilfinansiering'

export function useBankMarket(
  bankOrgNr: string,
  filters: BruktbilfinansieringFilters,
  selectedMerke: string[],
  selectedClasses: string[],
) {
  const [data, setData] = useState<BankMarketResponse | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchKey = JSON.stringify({
    bankOrgNr,
    startDate: filters.startDate,
    endDate: filters.endDate,
    dealerPostnummer: filters.dealerPostnummer ?? null,
    buyerPostnummer: filters.buyerPostnummer ?? null,
    varebil: filters.varebil,
    merke: [...selectedMerke].sort(),
    classes: [...selectedClasses].sort(),
  })

  useEffect(() => {
    let cancelled = false
    async function run() {
      setLoading(true)
      setError(null)
      try {
        const res = await bruktbilfinansieringAPI.getBankMarket(bankOrgNr, {
          start_date: filters.startDate,
          end_date: filters.endDate,
          dealer_postnummer: filters.dealerPostnummer ?? undefined,
          buyer_postnummer: filters.buyerPostnummer ?? undefined,
          varebil: filters.varebil,
          merke: selectedMerke.length ? selectedMerke : undefined,
          classes: selectedClasses.length ? selectedClasses : undefined,
        })
        if (!cancelled) setData(res.data)
      } catch (e: unknown) {
        if (!cancelled) setError(e instanceof Error ? e.message : i18n.t('errors.bankMarket', { ns: 'bbf' }))
      } finally {
        if (!cancelled) setLoading(false)
      }
    }
    run()
    return () => { cancelled = true }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchKey])

  return { data, loading, error }
}
